<template>
  <section class="container">


        <model-viewer id="modelV" ref="modelV" preload ar class="embed" src="/static/lower.glb" ios-src="/static/lower.usdz" camera-controls background-color="#fff"></model-viewer>


  </section>
</template>


<script>


import { firestore } from '../main'
import firebase from 'firebase'

import * as THREE from 'three'
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js'
import { log } from 'util';

export default {
  name: 'profile',
  data () {
    return {

    }
  },

  methods: {
    // logViewer(){return console.log(modelViewer)},
    builder(newObject) {
      this.$store.dispatch("options");
    },
    findGLB(gallery){
      return gallery.glb != null ?
      gallery.glb :
      this.GLB
    },
    windowHandleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    checkValid(fieldName) {
      return fieldName != null && fieldName != "" ? true : false
    },
    save( blob, filename ) {
      let blobURL = window.URL.createObjectURL( blob )
      this.GLB = blobURL

      var link = document.getElementById("facebookDownload")
      link.href = URL.createObjectURL( blob )
      link.download = filename
    },
    saveString(text, filename ) {
        this.save( new Blob( [ text ], { type: 'text/plain' } ), filename )
    },
    saveArrayBuffer( buffer, filename ) {
        this.save( new Blob( [ buffer ], { type: 'model/gltf-binary' } ), filename )
    },
    createGLB(){
      firestore.collection('artwork').doc(this.pageUID).get()
      .then((doc) => {

        let self = this
        let GetArtwork = this.gallery.photoURL
        let gallery = this.gallery
        const gltfExporter = new GLTFExporter()
        let loader = new THREE.TextureLoader()
        let Artowrk

        loader.setCrossOrigin('anonymous')

        // call a loader.load( <texture link here> ) for each texture used
        let canvas = loader.load('/static/textures/canvas.jpg')
        loader.load(
          GetArtwork,
           ( GetArtwork  ) => {

            // textures of the artwork
            const materials = [

              new THREE.MeshStandardMaterial( { map: canvas } ),
              new THREE.MeshStandardMaterial( { map: canvas } ),
              new THREE.MeshStandardMaterial( { map: canvas } ),
              new THREE.MeshStandardMaterial( { map: canvas } ),
              new THREE.MeshStandardMaterial( { map: GetArtwork } ),
              new THREE.MeshStandardMaterial( { map: canvas } )

            ]

            // dimensions of the artwork
            const geometry = new THREE.BoxGeometry( gallery.dimensions.width*0.0253, gallery.dimensions.height*0.0253, gallery.dimensions.depth*0.0253 )

            // combine the dimensions and textures into one variable
            const artwork = new THREE.Mesh( geometry, materials )
            artwork.rotation.y = 0.2;


            // GLTF model options
            const options = {
              trs: false,
              onlyVisible: true,
              truncateDrawRange: true,
              binary: true,
              forceIndices: false,
              embedImages: true,
              forcePowerOfTwoTextures: false
            }

          // export artwork into a blob to delcare or to download
          gltfExporter.parse( artwork , function( result ) {
            if ( result instanceof ArrayBuffer ) {
              self.saveArrayBuffer( result, 'artwork.glb' )
            } else {
              var output = JSON.stringify( result, null, 2 )
              console.log( output )
              self.saveString( output, 'artwork.gltf' )
            }
          }, options )

          },

          // onProgress callback currently not supported
          undefined,

          // onError callback
          function ( err ) {
            console.error( 'An error happened.' );
          }
      )
    })

    }

  },
  mounted() {

    const modelV = document.getElementById("modelV")
    modelV.activateAR()

  }
}

</script>

<style scoped>

#modelV {
position: fixed;
width: 100%;
height: 100%;
z-index: 999999;
bottom: 0;
}
.merge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;

  
}
.merge p {
  text-align: left;
  width: 90%; 
}

.qrcode {
  margin: 2em auto;
  mix-blend-mode: multiply;
  position: absolute;
}


.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.link {
  background-color: #000;
  left:  16px;
  bottom: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  background-size: 30px;
  background-position: 5px center;
  background-repeat: no-repeat;
}

.info h4 {
  font-size: 1em;
  padding: 0;
  font-weight: 400;
  letter-spacing: 0.1em;
  margin: 1em 0 1em 0;
  color: #555;
}

.info h3 {
    font-size: 3em;
    padding: 0;
    font-weight: 600;
    color: #444;
    margin: 0 0 0.7em 0;
    line-height: 1em;
}

.info p {
  font-size: 1.4em;
  padding: 0;
  font-weight: 400;
  letter-spacing: 0.1em;
  margin: 1em 0 0 0;

  }

  .info p .conversion {
    display: flex;
    flex-flow: row;
    align-items: center;
  }
  .info p .conversion img {
    width: 20px;
    margin: 0 10px 0 0;
  }

/* .medium margin */
.info p:nth-child(3){
  margin-bottom: 2em;
}

 .info div.artwork-description p {
    font-style: italic;
    margin: 3em 0;
    font-size: 18px;
    line-height: 1.4em;
    margin: 0;
  }

.info {
  width: 100%;
  margin: 0 auto;
  text-align: left;
  /* border-left: 3px solid #444; */
  padding: 1em 0 1em 18px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.profile-container {
  border-radius: 0;
  width: 45%;

}

.profile-container img {
  width: 100%;
}
.profile-container a  {
  width: 100%;
  position: relative;
}

.profile-container a img {
  width: 65%;
}

.view-in-room {
  box-shadow: 3px 3px 10px #ddd;
  /* border-radius: 50px; */
  margin: 1em auto;
  background-color: rgba(255, 255, 255, 0.1);
}

.hide-desktop {
  display: none;
}

.prevPage{
  display:block;
  text-decoration: underline;
  text-align: left;
  z-index: 100;
  padding: 1em;
  background: #fff;
  height: 1em;
}
.whiteBackground{
  background: #fff;
}
.greyBackground{
  background: #eee;
}


@media only screen and (max-width: 1200px) {

  .hide-desktop {
    display: block;
  }
  /* .info {
    width: 90%;
    padding: 0;
    margin: 0 auto;
  }

.container {
  flex-direction: column;
  padding: 0;
}

.art-container {
  width: 100%;
} */
}
@media only screen and (max-width: 900px) {


  .info {
    width: 90%;
    padding: 0 0 0 10px;
    margin: 5px auto;
  }

  .container {
    flex-direction: column;
    padding: 0;
  }

  .profile-container {
    width: 100%;
  }


  /* .info {
    width: 90%;
    padding: 1em 0;
    margin: 0 auto;
  } */

  .qr-container {
    width: 100%;
    background-color: white;
    padding: 2em 0;
    box-shadow: 3px -3px 10px #ddd;
    text-align: center;
  }

  .qr-container .info  {
    margin: 0 auto;
    text-align: center;
  }

.container {
  flex-direction: column;
  padding: 0;
}

.profile-container{
  width: 100%;
}

}
</style>



// WEBPACK FOOTER //
// src/components/Viewer.vue